<template>
    <b-table
        :data="records"
        :striped="true"
        :loading="loading"
        :mobile-cards="true"

        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
        backend-sorting
        :default-sort-direction="sortOrder"
        :default-sort="[sortField, sortOrder]"
        @sort="onSort"

        :paginated="paginated"
        :sort-icon="'chevron-up'"
        class="table-with-dropdown"
    >
        <template>
            <b-table-column v-slot="props" field="number" label="Factuur nr." width="160" sortable>
                <router-link :to="{ name: type === 'geescaleerd' ? 'EscalationRecord' : 'InvoicesRecord', params: {type: props.row.type, id: props.row.id} }">
                    <strong>{{ props.row.number }}</strong>
                </router-link>
            </b-table-column>

            <b-table-column v-slot="props" field="customer" label="Klant" sortable v-if="type != 'customer'">
                <b-button tag="router-link" type="is-primary" size="is-small" :to="{ name: 'CustomersRecord', params: {id: props.row.customer.id} }" v-if="props.row.customer">
                    <span v-if="hideSensitiveData">********</span>
                    <span v-else>
                        {{ props.row.customer.firstname }}&nbsp;{{ props.row.customer.lastname }}
                    </span>
                </b-button>
                <span v-else>-</span>
            </b-table-column>

            <b-table-column v-slot="props" field="boxes" label="Box nr." width="160" v-if="user.organisation_type && user.organisation_type == 'box' && type == 'customer'">
                <span v-for="(box, index) in _.uniqBy(props.row.boxes, (box) => box.box.id )" :key="box.id">
                    <b-button tag="router-link" :to="{ name: 'BoxesRecord', params: {id: box.box.id} }" type="is-light" size="is-small" v-if="index < 2">
                        {{ box.box.number|truncate(10, '..') }}
                    </b-button>
                    <b-tooltip v-if="index >= 2" :label="props.row.boxes.slice(2).map(box => box.box.number).join(', ')">
                        <b-button type="is-light" size="is-small">+{{ props.row.boxes.length - 2 }}</b-button>
                    </b-tooltip>
                </span>
            </b-table-column>

            <b-table-column v-slot="props" field="status" label="Status" width="120" sortable>
                <!-- <b-tag :type="_.isNull(props.row.status) ? 'is-dark' : props.row.status == 'paid' ? 'is-success' : _.includes(['multiple_fails', 'storno'], props.row.status) ? 'is-danger' : _.includes(['one_fail'], props.row.status) ? 'is-warning' : _.includes(['cancelled', 'reminder_1', 'reminder_2'], props.row.status) ? 'is-warning' : 'is-info'">{{ invoiceStatus(props.row.status) }}</b-tag> -->
                <InvoiceStatus
                    :id="props.row.id"
                    :status="props.row.status"
                    :send_at="props.row.send_at"
                    :payments="props.row.invoice_payments"
                    :type="props.row.type"
                    @reload="loadAsyncData"
                />
                <!-- <b-tooltip label="Handmatige actie vereist" v-show="props.row.status != 'paid' && props.row.contract && props.row.contract.payment_type == 'manual'" style="float: left;margin-right: 5px;">
                    <b-icon icon="exclamation-circle" type="is-danger" />
                </b-tooltip> -->
            </b-table-column>

            <b-table-column v-slot="props" field="total" label="Totaal" width="100" numeric sortable>
                <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                <span v-else-if="props.row.total" :class="{ 'text-danger': props.row.type == 'credit' }">{{ props.row.type == 'credit' ? '- ': '' }}€&nbsp;{{ props.row.total }}</span>
                <span v-else>-</span>
            </b-table-column>

            <b-table-column v-slot="props" label="PDF" width="120">
                <a :href="'/uploads'+props.row.pdf" target="_blank" v-if="props.row.pdf">Download PDF</a>
                <span v-else>-</span>
            </b-table-column>

            <b-table-column v-slot="props" field="invoice_date" label="Datum" width="120" sortable>
                {{ props.row.invoice_date|humanDate }}
            </b-table-column>

            <!-- <b-table-column v-slot="props" field="send" :label="type == 'recent' ? 'Verstuurd' : 'Gepland voor'" width="180" sortable>
                <span v-if="!_.isNull(props.row.send_at)">{{ props.row.send_at|humanDate }}</span>
                <span v-else>
                    <span v-if="type == 'recent'"><b-icon icon="clock" pack="far" /></span>
                    <span v-else>{{ props.row.invoice_date|humanDate }}</span>
                </span>
            </b-table-column> -->

            <b-table-column v-slot="props" numeric width="100">
                <InvoiceOptionsDropdown
                    :type="props.row.type"
                    :record="props.row"
                    @reloadInvoices="loadAsyncData"
                />
            </b-table-column>
        </template>

        <template #empty>
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p class="margin0" v-if="loading === false">Geen facturen gevonden.</p>
                    <p class="margin0" v-else>Laden...</p>
                </div>
            </section>
        </template>
    </b-table>
</template>

<script>
import InvoiceOptionsDropdown from '@/vue/invoices/components/InvoiceOptionsDropdown'
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'InvoicesTable',

    components: {
        InvoiceOptionsDropdown
    },

    mixins: [filtersMixin, paramsMixin],

    props: {
        type: {
            type: String,
            required: true
        },

        id: {
            type: Number|String,
            required: true
        },

        // Example: :extraParams="[{ activecontract: true }]"
        extraParams: {
            type: [Array, Boolean],
            default: false
        }
    },

    data() {
        return {
            records: [],

            total: 0,
            loading: false,
            sortField: this.$route.params.type == 'recent' ? 'send_at' : 'invoice_date',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 12,
            searchParams: _.has(this.$store.state.searchQueries, [this.type+'_Invoices']) ? this.$store.state.searchQueries[this.type+'_Invoices'] : null
        }
    },

    computed: {
        paginated() {
            return this.records && this.records.length < this.total
        },

        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    created(){
        // Check if in this session a query is saved (last success) else use default sorting.
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    methods: {
        loadAsyncData() {
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, this.type+'_Invoices', false) // added false to not use dataBelongsTo in this case.
            let extraParams = this.extraParams ? this.extraParams : []
            this.loading = true
            let url = false

            // Push extra params when given but dont save them in the store.
            if (this.extraParams) {
                extraParams = this.extraParams.map((param) => {
                    return Object.keys(param).map((key) => {
                        return key + '=' + param[key]
                    }).join('&')
                })
            }

            switch (this.type) {
                case 'customer':
                    url = `/api/customer/${this.id}/invoices?${extraParams ? extraParams.join('&') : ''}${params ? '&' + params : ''}`
                break;
                case 'box':
                    url = `/api/box/${this.id}/invoices?${extraParams ? extraParams.join('&') : ''}${params ? '&' + params : ''}`
                break;
                case 'product':
                    url = `/api/product/${this.id}/invoices?${extraParams ? extraParams.join('&') : ''}${params ? '&' + params : ''}`
                break;
                case 'contract':
                    url = `/api/contract/${this.id}/invoices?${extraParams ? extraParams.join('&') : ''}${params ? '&' + params : ''}`
                break;
            }

            if(!url) return false;
            axios.get(url, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$emit('passTotal', response.data.total)

                this.$store.dispatch('setSearchQuery', {type: this.type+'_Invoices', query: params})
            }).catch((error) => {
                console.error(`[❌] Error while fetching ${this.type}:`, error)
                this.data = []
                this.total = 0
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },
        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        }
    }
}
</script>
